import { createFileRoute } from '@tanstack/react-router';

import { CheckinConfigPage } from '../modules/location-checkin-config/ui/pages/CheckinConfigPage';

// NOTE: .index.tsx suffix is REQUIRED here (same pattern as niche-config + tariff + zones routes).
// Without the .index suffix, TanStack Router treats the file as a layout component
// and wraps child routes instead of rendering the page. See JQ4-11 WU-13 gotcha.
export const Route = createFileRoute(
  '/_authenticated/dashboard/locations/$locationId/checkin-config/',
)({
  component: CheckinConfigPage,
  staticData: {
    breadcrumb: ['Manage', 'Locations', 'Check-in Fields'],
  },
});
